import type { ComponentProps } from "react";
import type { Scale } from "@ptsd/uikit";

import type { RouterOutputs } from "~/utils/api";

export interface ScaleAccordionContent {
  id: string;
  title: string;
  content: string;
}

type StatState = ComponentProps<typeof Scale.StatCard>["state"];

interface StatCard {
  score: string | number;
  state: StatState;
  description: string;
}

type HeaderState = ComponentProps<typeof Scale.ManagerHeader>["state"];

export interface ScaleCardContentData {
  id: string;
  scale: string;
  //  score: number;
  title: string;
  state: HeaderState;
  stateText: string | undefined;
  toogleLabel: string;
  accordion: ScaleAccordionContent[];
  interpretation: string | undefined;
  stats: StatCard[];
  danger: boolean | undefined;
}

type ScalesItems = RouterOutputs["dashboard"]["getSphereInfo"]["scales"];

export const isNonEmptyString = (value: unknown) =>
  typeof value === "string" && value.trim() !== "";

const scalesLevelToState = {
  neutral: "neutral",
  low: "success",
  belowMedium: "success",
  medium: "warning",
  aboveMedium: "danger",
  high: "danger",
} satisfies Record<string, StatState>;

export const normalizeScales = (data: ScalesItems) => {
  return data.map((scale, i) => {
    return {
      id: "scale" + i,
      stats: scale.stats.map((stat) => {
        return {
          score: stat.percentage + "%",
          state: scalesLevelToState[stat?.level ?? "neutral"],
          description: stat.name,
        };
      }),
      scale: scale.scale,
      title: scale.name,
      state: "success",
      stateText: undefined,
      toogleLabel: "Детальний опис",
      danger: scale.danger,
      interpretation: scale.interpretation,
      accordion: [
        isNonEmptyString(scale.description)
          ? {
              id: "description",
              title: "Що таке шкала " + scale.name,
              content: scale.description,
            }
          : undefined,
      ].filter(Boolean) as { title: string; content: string; id: string }[],
    };
  }) satisfies ScaleCardContentData[];
};

export const scalesColorsByLevel = (level: string | undefined) => {
  switch (level) {
    case "high":
    case "aboveMedium":
      return { color: "$error-500", bgColor: "$error-500-o005" };
    case "medium":
      return { color: "$warning-500", bgColor: "$warning-100" };
    case "belowMedium":
    case "low":
      return { color: "$score-8", bgColor: "$lightgreen-100" };
    default:
      return { color: "$color", bgColor: "$gray-100" };
  }
};
